<template>
  <div class="mb-5">
    <h5 class="card-title">Upcoming Events</h5>
    <div class="row">
      <a
        class="col-md-6 mb-3 mb-md-4"
        v-for="event in displayEvents"
        :key="event.id"
        v-router-link="{ name: 'EventDetail', params: { id: event.id } }"
      >
        <div class="card">
          <div
            class="picture"
            v-imagekit.background="{
              image: event.picture,
              transform: 'w-110,h-170,fo-auto'
            }"
          >
            <img
              class="sr-only"
              v-imagekit.src="{
                image: event.picture,
                transform: 'w-110,h-170,fo-auto'
              }"
            />
          </div>
          <div class="info">
            <div class="date">
              {{ event.start | moment('D') }} {{ event.start | moment('MMM') }}
            </div>
            <h3>{{ event.name | truncate(40, '...') }}</h3>
            <hr />
            <div class="event-location" v-if="event.cityId">
              {{ event.city.name }}
            </div>
            <div class="event-metadata">
              <!-- <span class="attendees">{{ event.responses_aggregate.aggregate.count }} attending</span> -->
              <span class="circle"></span>
              <span class="price" v-if="event.price"
                >{{ event.currency }} {{ event.price }}</span
              >
              <span class="price" v-if="!event.price">Free</span>
            </div>
          </div>
        </div>
      </a>
    </div>

    <see-more-button
      v-if="events.length > 2"
      :count="events.length - 2"
      @showMore="status => (showMore = status)"
    ></see-more-button>
  </div>
</template>
<script>
import SeeMoreButton from '../global/SeeMoreButton';

export default {
  name: 'network-events-card',

  props: ['events'],

  components: {
    SeeMoreButton
  },

  data() {
    return {
      showMore: false
    };
  },

  computed: {
    displayEvents() {
      return this.showMore ? this.events : this.events.slice(0, 2);
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  padding: 0;
  display: flex;
  flex-direction: row;
  border: none;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  height: 100%;

  .picture {
    width: 100px;
    background-color: $grey;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    overflow: hidden;
    display: none;
    @include media-breakpoint-up(md) {
      display: inline-block;
    }
  }

  .info {
    padding: 25px;
    width: 100%;
    @include media-breakpoint-up(md) {
      width: 70%;
    }
  }

  h3 {
    font-weight: 700;
  }

  .date {
    color: $primary;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 15px;
    margin-bottom: 5px;
    @include media-breakpoint-up(md) {
      color: $grey-text;
    }
  }

  hr {
    margin: 10px 0;
  }
  .event-location {
    color: $secondary;
  }

  .event-metadata {
    font-size: 14px;
  }

  .circle {
    display: inline-block;
    width: 4px;
    height: 4px;
    background-color: $grey;
    border-radius: 50%;
    margin: 0 10px;
    vertical-align: middle;
  }

  .attendees {
    color: $grey;
  }

  .price {
    font-size: 15px;
    color: #505b64;
  }
}
</style>
